jQuery(document).ready(function ($) {

	// RECARGAR CRYPTO-MINI
	let reload_mini = $('#cotizaciones.crypto-mini').attr('data-reload_module');
	if (reload_mini === "true") {

		let crypto_mini_id = $('#cotizaciones.crypto-mini').attr('data-id');
		$.getJSON(
			"/wp-json/fstock-pages/v1/update_crypto_mini/" + crypto_mini_id,
			{t: Math.random()},
			function (response) {
				if (response) {
					let data = response.data;
					let currentComp = $('#cotizaciones.crypto-mini');

					currentComp.attr('data-origin', 'Ajax mini');
					currentComp.find('#price-mini-txt').text(data.current_price);
					currentComp.find('#time-mini-txt').text(data.time_mini);
					currentComp.find('#percentage-mini-1-txt').text(data.price_change_percentage_1h_in_currency);
					currentComp.find('#percentage-mini-24-txt').text(data.price_change_percentage_24h_in_currency);
					currentComp.find('#percentage-mini-7-txt').text(data.price_change_percentage_7d_in_currency);
				}
			}
		);

	}
	// END RECARGAR CRYPTO-MINI

	// RECARGAR CRYPTO-SUMMARY
	let reload_summary = $('#cotizaciones.crypto-summary').attr('data-reload_module');
	if (reload_summary === "true") {

		let crypto_summary_id = $('#cotizaciones.crypto-summary').attr('data-id');
		$.getJSON(
			"/wp-json/fstock-pages/v1/update_crypto_summary/" + crypto_summary_id,
			{t: Math.random()},
			function (response) {
				if (response) {
					let data = response.data;
					let currentComp = $('#cotizaciones.crypto-summary');

					currentComp.attr('data-origin', 'Ajax summary');
					currentComp.find('#summary-price-market-cap').text(data.market_cap);
					currentComp.find('#summary-price-total-vol').text(data.total_volume);
					currentComp.find('#summary-price-fully-dil').text(data.fully_diluted_valuation);
					currentComp.find('#summary-price-circ-supply').text(data.circulating_supply);
					currentComp.find('#summary-price-max-supply').text(data.max_supply);
					currentComp.find('#summary-price-min').text(data.min);
					currentComp.find('#summary-price-max').text(data.max);
				}
			}
		);

	}
	// END RECARGAR CRYPTO-SUMMARY

	// RECARGAR CRYPTO-HISTORICOS
	let reload_historicos = $('#cotizaciones.crypto-table-percentage').attr('data-reload_module');
	if (reload_historicos === "true") {

		let crypto_historicos_id = $('#cotizaciones.crypto-table-percentage').attr('data-id');
		$.getJSON(
			"/wp-json/fstock-pages/v1/update_crypto_historico/" + crypto_historicos_id,
			{t: Math.random()},
			function (response) {
				if (response) {
					let data = response.data;
					let currentComp = $('#cotizaciones.crypto-table-percentage');

					currentComp.attr('data-origin', 'Ajax historico');
					currentComp.find('#price-change-1h').text(data.price_change_percentage_1h_in_currency);
					currentComp.find('#price-change-24').text(data.price_change_percentage_24h_in_currency);
					currentComp.find('#price-change-7').text(data.price_change_percentage_7d_in_currency);
					currentComp.find('#price-change-14').text(data.price_change_percentage_14d_in_currency);
					currentComp.find('#price-change-30').text(data.price_change_percentage_30d_in_currency);
					currentComp.find('#price-change-200').text(data.price_change_percentage_200d_in_currency);
					currentComp.find('#price-change-1y').text(data.price_change_percentage_1y_in_currency);
				}
			}
		);

	}
	// END RECARGAR CRYPTO-HISTORICOS

	// ACTUALIZACIÓN TABLA CRYPTOS
	let reload_table = $('#cotizaciones.crypto-table').attr('data-reload_module');
	if (reload_table === "true") {

		let page = $('#cotizaciones.crypto-table').attr('data-page');
		$.getJSON(
			"/wp-json/fstock-pages/v1/update_crypto_table/crypto_table-" + page,
			{
				t: Math.random()
			},
			function (response) {
				if (response) {
					$('#cotizaciones.crypto-table').attr('data-origin', 'Ajax table');

					let currentComp = $('#cotizaciones.crypto-table tbody');
					Object.entries(response.data).forEach(([code, component]) => {
						let tr = currentComp.find('.' + component.id);

						tr.find('#crypto-table-price').text(component.current_price)
						tr.find('#crypto-table-percentage-1').text(component.price_change_percentage_1h_in_currency)
						tr.find('#crypto-table-percentage-24').text(component.price_change_percentage_24h_in_currency)
						tr.find('#crypto-table-percentage-7').text(component.price_change_percentage_7d_in_currency)
						tr.find('#crypto-table-total-vol').text(component.total_volume)
						tr.find('#crypto-table-market-cap').text(component.market_cap)
					});
				}
			}
		);

	}
	// END ACTUALIZACIÓN TABLA CRYPTOS

	// RECARGAR TICKER
	let reload_module = $('#reload-module').attr('data-reload_module');
	if (reload_module === "true") {
		recargar_ticker();
	}

	function recargar_ticker() {
		const ticker = $('#ticker-master').attr('data-type');

		$.getJSON(
			"/wp-json/fstock-pages/v1/update_ticker_master/" + ticker,
			{t: Math.random()},
			function (response) {
				if (response) {
					let parent = $('#ticker-master').parent();
					$('#ticker-master').remove();

					parent.append(response.ticker);

					$('#ticker-master').attr('data-origin', 'Ajax ticker');

					calc_width_sepeardor_ticker();
				}
			}
		);
	}
	// END RECARGAR TICKER

	// Calcular el ancho del span separador del ticker
	calc_width_sepeardor_ticker();
	function calc_width_sepeardor_ticker() {
		let width_stocks = 0;
		$('#ticker-master ul.contenidoticker li').each(function () {
			width_stocks += $(this).outerWidth(true);
		})

		let width_crypto = 0;
		$('#ticker-master ul.contenidotickercrypto li').each(function () {
			width_crypto += $(this).outerWidth(true);
		})

		if(width_stocks > width_crypto) {
			$('#ticker-master ul.contenidotickercrypto').css('width', width_stocks+'px')
		}
	}
	// END Calcular el ancho del span separador del ticker

	// BTN TICKERS UPDATE
	$('#ticker-updater').css('display', 'none');
	setTimeout(function () {
		$('#ticker-updater').css('display', 'inline');
	}, 30000);

	$("#ticker-updater").on('click', 'a', function (e) {
		e.preventDefault();

		$('#ticker-updater').css('display', 'none');
		$('#ticker-status').css('display', 'inline');

		update_stocks();
		update_cryptos();
	});
	// END BTN TICKERS UPDATE

	// ACTUALIZACIÓN TICKER STOCKS
	function update_stocks(animation = true, callback = null) {
		let params = [];
		$(".contenidoticker .component").each(function () {
			let code = $(this).data('code');
			let type = $(this).data('type');
			params.push(code + '|' + type);
		});

		$.getJSON(
			"/wp-json/fstock-pages/v1/stocks/" + params.join(','),
			{
				t: Math.random()
			},
			function (response) {

				if (response) {
					Object.entries(response.data).forEach(([code, component]) => {
						const currComponent = $('#comp-' + code + '-' + component.type);
						const currValue = currComponent.data('value');

						if ((currValue != component.value) && (component.percentage_variation != null)) {
							let percentage = parseFloat(component.percentage_variation.replace('.', '').replace(',', '.'));

							if (percentage < 0) {
								currComponent.find('.suben-ticker').removeClass('suben-ticker').addClass('bajan-ticker');
								currComponent.find('.mant-ticker').removeClass('mant-ticker').addClass('bajan-ticker');
							} else if (percentage > 0) {
								currComponent.find('.bajan-ticker').removeClass('bajan-ticker').addClass('suben-ticker');
								currComponent.find('.mant-ticker').removeClass('mant-ticker').addClass('suben-ticker');
							} else {
								currComponent.find('.bajan-ticker').removeClass('bajan-ticker').addClass('mant-ticker');
								currComponent.find('.suben-ticker').removeClass('suben-ticker').addClass('mant-ticker');
							}
							currComponent.find('.stock-value').text(component.value);
							currComponent.attr('data-value', component.value);
							currComponent.find('.variacion .percentage').text(component.percentage_variation);
							currComponent.find('.variacion .absolut').text(component.variation);

							if (animation) {
								currComponent.fadeOut(500).fadeIn(500).fadeOut(500).fadeIn(500);
							}
						}
					});
					$('#ticker-status').hide();
				}

				$('.updated-time').text(response.updated);
				setTimeout(function () {
					$('#ticker-updater').css('display', 'inline');
				}, 30000);
			}
		);
	}

	// END ACTUALIZACIÓN TICKER STOCKS

	// ACTUALIZACIÓN TICKER CRYPTOS
	function update_cryptos(animation = true, callback = null) {
		let params = [];
		$(".contenidotickercrypto .component").each(function () {
			let code = $(this).data('code');
			let type = $(this).data('type');
			params.push(code + '|' + type);
		});

		$.getJSON("/wp-json/fstock-pages/v1/crypto/" + params.join(','), {t: Math.random()}, function (response) {
			if (response) {
				Object.entries(response.data).forEach(([code, component]) => {
					const currComponent = $('#comp-' + code + '-' + component.type);
					const currValue = currComponent.data('value');

					if (currValue != component.current_price && (component.price_change_percentage_1h_in_currency != null)) {
						let percentage = parseFloat(component.price_change_percentage_1h_in_currency.replace('.', '').replace(',', '.'));

						if (percentage < 0) {
							currComponent.find('.suben-ticker').removeClass('suben-ticker').addClass('bajan-ticker');
							currComponent.find('.mant-ticker').removeClass('mant-ticker').addClass('bajan-ticker');
						} else if (percentage > 0) {
							currComponent.find('.bajan-ticker').removeClass('bajan-ticker').addClass('suben-ticker');
							currComponent.find('.mant-ticker').removeClass('mant-ticker').addClass('suben-ticker');
						} else {
							currComponent.find('.bajan-ticker').removeClass('bajan-ticker').addClass('mant-ticker');
							currComponent.find('.suben-ticker').removeClass('suben-ticker').addClass('mant-ticker');
						}
						currComponent.find('.stock-value').text(component.current_price + " " + response.currency_symbol);
						currComponent.attr('data-value', component.current_price);
						currComponent.find('.variacion .percentage').text(component.price_change_percentage_1h_in_currency);

						if (animation) {
							currComponent.fadeOut(500).fadeIn(500).fadeOut(500).fadeIn(500);
						}
					}
				});
				$('#ticker-status').hide();
			}

			$('.updated-time').text(response.updated);
			setTimeout(function () {
				$('#ticker-updater').css('display', 'inline');
			}, 30000);

		});
	}

	// END ACTUALIZACIÓN TICKER CRYPTOS

	$('.stock-tabs ul.tabs li').click(function () {
		$('.stock-tabs ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.stock-tabs div.tab-data').each(function () {
			$(this).hide();
			var option = $(this).data("option");
			if (option === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.stock-summary .grafic-time ul li a').click(function () {
		$('.stock-summary .grafic-time ul li').each(function () {
			$(this).removeClass("select");
		});
		$(this).addClass("select");
		var seleccionado = $(this).attr("name");
		$('.stock-summary div.grafic-img').each(function () {
			$(this).hide();
			var option = $(this).attr("name");
			if (option === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.currencies-table ul.tabs li').click(function () {
		$('.currencies-table ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.currencies-table .currencies_layer').each(function () {
			$(this).hide();
			if ($(this).attr("id") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.rawmaterials-table ul.tabs li').click(function () {
		$('.rawmaterials-table ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.rawmaterials-table .rawmaterials_layer').each(function () {
			$(this).hide();
			if ($(this).attr("id") === seleccionado) {
				$(this).show();
			}
		});
	});

	$(".datos-divisa nav.grafic-time li a").click(function () {
		$(".datos-divisa nav.grafic-time li a").each(function () {
			$(this).parent().removeClass("select");
		});
		$(this).parent().addClass("select");
		var seleccionado = $(this).attr("name");
		$(".datos-divisa div.m-border div.grafic-img").each(function () {
			$(this).hide();
			if ($(this).attr("name") == seleccionado) {
				$(this).show();
			}
		});
	});

	$('.currency-top ul.tabs li').click(function () {
		$('.currency-top ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.currency-top .currencies_top_layer').each(function () {
			$(this).hide();
			if ($(this).attr("id") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.etfs-top ul.tabs li').click(function () {
		$('.etfs-top ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.etfs-top .etfs_top_layer').each(function () {
			$(this).hide();
			if ($(this).attr("id") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.rawmaterials-top ul.tabs li').click(function () {
		$('.rawmaterials-top ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.rawmaterials-top .rawmaterials_top_layer').each(function () {
			$(this).hide();
			if ($(this).attr("id") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.warrants-table').on('click', '.grafic-time .button', function () {
		var seleccionado = $('.warrants-table .grafic-time select').val();
		var opcion = $('.warrants-table .grafic-time li.select a').text();
		if (opcion.toLowerCase() == 'call') {
			opcion = 'C';
		} else if (opcion.toLowerCase() == 'put') {
			opcion = 'P';
		} else {
			opcion = '';
		}
		$.getJSON("/fstocks-utils/ifw", {seleccionado: seleccionado, opcion: opcion},
			function (data) {
				if (data.html) {
					$('.warrant-table .m-ranking').remove();
					$('.warrant-table').html(data.html);
				}
			});
	});

	$('.warrants-table').on('click', '.grafic-time li', function () {
		$('.warrants-table .grafic-time li').each(function () {
			$(this).removeClass("select");
		});
		$(this).addClass("select");
	});

	// main_market_summaries
	$('.main-markets-summaries li.market-tab').click(function () {
		$('.main-markets-summaries li.market-tab').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("slug");
		$('.main-markets-summaries .market-summary').each(function () {
			$(this).hide();
			if ($(this).data("slug") === seleccionado) {
				$(this).show();
				$(this).find('div.m-border').show();
			}
		});
	});

	$('.ibex-summary-tabs ul.tabs li').click(function () {
		$('.ibex-summary-tabs ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.ibex-summary-tabs div.data-layer').each(function () {
			$(this).hide();
			if ($(this).data("option") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.madrid-summary-tabs ul.tabs li').click(function () {
		$('.madrid-summary-tabs ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.madrid-summary-tabs div.data-layer').each(function () {
			$(this).hide();
			if ($(this).data("option") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.ibex_values_profit ul.tabs li').click(function () {
		$('.ibex_values_profit ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.ibex_values_profit div.data-layer').each(function () {
			$(this).hide();
			if ($(this).data("option") === seleccionado) {
				$(this).show();
			}
		});
	});

	$('.stock-markets ul.tabs li').click(function () {
		$('.stock-markets ul.tabs li').each(function () {
			$(this).removeClass("selected");
		});
		$(this).addClass("selected");
		var seleccionado = $(this).data("option");
		$('.stock-markets div.data-layer').each(function () {
			$(this).hide();
			if ($(this).data("option") === seleccionado) {
				$(this).show();
			}
		});
	});

	$(".datos-m_prima nav.grafic-time li a").click(function () {
		$(".datos-m_prima nav.grafic-time li a").each(function () {
			$(this).parent().removeClass("select");
		});
		$(this).parent().addClass("select");
		var seleccionado = $(this).attr("name");
		$(".datos-m_prima div.m-border div.grafic-img").each(function () {
			$(this).hide();
			if ($(this).attr("name") == seleccionado) {
				$(this).show();
			}
		});
	});

	$("#cotizaciones nav.grafic-time li a").click(function () {
		$("#cotizaciones nav.grafic-time li a").each(function () {
			$(this).parent().removeClass("select");
		});
		$(this).parent().addClass("select");
	});

});
